/**
 * rawStorage.js — the UNPATCHED localStorage writers.
 *
 * preferencesSync monkey-patches localStorage.setItem/removeItem so any
 * write to a synced key is mirrored to the account on the server. That's
 * the right default, but a few writes are deliberately browser-local and
 * must NOT reach the server — above all the logout wipe, which clears
 * this browser's copy of personal data. Routing that through the patched
 * removeItem would push `null` for every wiped key and delete the
 * account's saved preferences (your theme, on every other device).
 *
 * A leaf module with no imports so both preferencesSync and
 * userScopedStorage can use it without an import cycle. The natives are
 * captured at module load, which is long before initPreferencesSync()
 * installs the patches.
 */
let _setItem = () => {};
let _removeItem = () => {};
try {
  _setItem = localStorage.setItem.bind(localStorage);
  _removeItem = localStorage.removeItem.bind(localStorage);
} catch { /* storage blocked — writes become no-ops, as they would anyway */ }

/** Write without marking the key dirty for server sync. */
export function rawSetItem(key, value) {
  try { _setItem(key, value); } catch { /* quota / private mode */ }
}

/** Remove without telling the server to delete the account's copy. */
export function rawRemoveItem(key) {
  try { _removeItem(key); } catch { /* private mode */ }
}
